import { Button } from '@/components/ui/button';
import { useMasterApprenticesStatStore } from '@/features/teacher-student-stat/store';
import { exportTeacherStudentRepublicToExcel } from '@/features/teacher-student-stat/utils/exportTeacherStudentToExcel';
import { Download } from 'lucide-react';
import { FC, useState } from 'react';
import { MasterApprenticesFilter } from '../../filter';
import { TeacherStudentHeader } from '../../header/Header';
import { TableDistrict } from './table/TableDistrict';

export const TeacherStudentStatDistrict: FC = () => {
  const { masterApprenticesRegionResponse } = useMasterApprenticesStatStore();

  const [mastersTotal, setMastersTotal] = useState(0);
  const [apprenticesTotal, setApprenticesTotal] = useState(0);

  const hasRows = (masterApprenticesRegionResponse?.rows.length ?? 0) > 0;

  const handleTotalsChange = (masters: number, apprentices: number) => {
    setMastersTotal(masters);
    setApprenticesTotal(apprentices);
  };

  const handleExport = async () => {
    if (masterApprenticesRegionResponse) {
      await exportTeacherStudentRepublicToExcel(
        masterApprenticesRegionResponse,
        `ustoz-shogird-${masterApprenticesRegionResponse?.region?.region_name?.toLocaleLowerCase()}`,
      );
    }
  };

  return (
    <div className="flex flex-col gap-4 p-8">
      <div className="flex items-center justify-between">
        <TeacherStudentHeader
          title={`${masterApprenticesRegionResponse?.region?.region_name} bo'yicha ustoz-shogirdlar`}
          mastersTotal={mastersTotal}
          apprenticesTotal={apprenticesTotal}
        />
      </div>
      <div className="flex items-center justify-between">
        <MasterApprenticesFilter />
        {hasRows && (
          <Button
            onClick={handleExport}
            className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white"
          >
            <Download className="size-4" />
            Excel
          </Button>
        )}
      </div>

      <TableDistrict onTotalsChange={handleTotalsChange} />
    </div>
  );
};
